export default "__VITE_ASSET__DJ$yKvaf__"